import React from 'react';
import { Box, Tooltip, TooltipProps, Typography } from '@mui/material';

interface InfoTooltipProps {
	/** Body text. Pass an array to render multiple paragraphs. */
	content: string | string[];
	/** Optional bold heading shown above the body. */
	heading?: string;
	placement?: TooltipProps['placement'];
	children: React.ReactElement;
}

/**
 * Shared dark info tooltip used across the Deterioration Model views.
 * Renders a bold heading and one or more body paragraphs with an arrow.
 */
export const InfoTooltip = ({
	content,
	heading,
	placement = 'bottom-start',
	children,
}: InfoTooltipProps): JSX.Element => {
	const paragraphs = Array.isArray(content) ? content : [content];

	return (
		<Tooltip
			placement={placement}
			arrow
			title={
				<Box sx={{ p: 0.5, maxWidth: 320 }}>
					{heading && <Typography sx={{ fontWeight: 600, fontSize: '0.8125rem', mb: 0.75 }}>{heading}</Typography>}
					{paragraphs.map((paragraph, index) => (
						<Typography
							key={paragraph}
							sx={{
								fontSize: '0.75rem',
								color: 'rgba(255,255,255,0.85)',
								mb: index < paragraphs.length - 1 ? 0.5 : 0,
							}}>
							{paragraph}
						</Typography>
					))}
				</Box>
			}>
			{children}
		</Tooltip>
	);
};
